// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"124":"00457985","365":"00457985"}[chunkId] + ".chunk.css";
};